import React from 'react';
import { IProps } from 'components/MainContent/types';
import CaptchaErrorModal from 'components/CaptchaErrorModal';
import CaptchaSendModal from 'components/CaptchaSendModal';
import CaptchaReturnModal from 'components/CaptchaReturnModal';
import GuardianshipStatementModal from 'components/GuardianshipStatementModal';
import FillPassportModal from 'components/FillPassportModal';
import LoadingModal from 'components/LoadingModal';
import RuleValidErrorModal from 'components/RuleValidErrorModal';
import InfoModal from 'components/InfoModal';
import GameQualifyModal from 'components/GameQualifyModal';

const MainContent: React.FC<IProps> = (props) => (
  <>
    <div className="main-content">
      {props.children}
    </div>

    {/* Modal - 抽獎活動資格提示 */}
    <GameQualifyModal />
    {/* Modal - 驗證碼錯誤 剩餘 3 次機會   ps. display with redux state */}
    <CaptchaErrorModal />
    {/* Modal - 驗證碼錯誤 返回上一頁重新填寫   ps. display with redux state */}
    <CaptchaSendModal />
    {/* Modal - 驗證碼錯誤 返回上一頁重新填寫   ps. display with redux state */}
    <CaptchaReturnModal />
    {/* Modal - 顯示資訊用  ps. display with redux state */}
    <InfoModal />
    {/* Modal - 監護宣告說明   ps. display with redux state */}
    <GuardianshipStatementModal />
    {/* Modal - 如需申請英文投保證明，請填寫被保人護照資料   ps. display with redux state */}
    <FillPassportModal />
    {/* Modal - Loading   ps. display with redux state */}
    <LoadingModal />
    {/* Modal - 保單規則檢核-錯誤   ps. display with redux state */}
    <RuleValidErrorModal />
  </>
);

export default MainContent;
